import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/home';

export default function HotMovies() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <h3 className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-2">
              <i className="ri-fire-line mr-1.5"></i>
              热门推荐
            </h3>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              大家都在看
            </h2>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Movie grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={movie.link}
              className="group cursor-pointer"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              {/* Poster */}
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Rating badge */}
                <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-black/70 backdrop-blur-sm rounded-md px-2 py-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-white text-xs font-medium">{movie.rating}</span>
                </div>
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-white text-xs leading-relaxed line-clamp-3">{movie.desc}</p>
                </div>
              </div>

              {/* Info */}
              <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {movie.title}
              </h4>
              <p className="text-xs text-foreground-500">{movie.category} · {movie.year}</p>
            </Link>
          ))}
        </div>

        {/* Mobile view all */}
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部热门 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}